export type ToolAccessBindings = {
  /** True only when the user's permissions are loaded and lack the tool's open permission. */
  isToolOpenDenied: (agentId: string) => boolean;
};

let bindings: ToolAccessBindings | null = null;

/** Called once at boot; tests may call it again to replace the bindings. */
export const configureToolAccess = (next: ToolAccessBindings): void => {
  bindings = next;
};

/** False while unbound, so an unwired surface asks the server rather than hiding an agent. */
export const isToolOpenDenied = (agentId: string): boolean =>
  bindings?.isToolOpenDenied(agentId) ?? false;
